<template>
  <div class="popupView">
    <div class="popupTopView">
      <div class="filterView" v-for="(item,index) in filterItems" :key="index">
        <div class="rowFlex alignitems jus-btw">
          <div class="filterTitle">{{ item.name }}</div>
        </div>
        <div class="filterListView" v-if="item.bsLabel && item.bsLabel.length > 0">
          <div
              :class="['filterItem ',selectFilterItemIds[item.id] && selectFilterItemIds[item.id].indexOf(fItem.id) > -1 ? 'activeItem' : 'normalItem']"
              v-for="(fItem,fIndex) in item.bsLabel"
              :key="fIndex"
              @click="handleSelect(item,fItem)"
          >
            {{ fItem.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="popupBottomView">
      <div class="actionView">
        <!-- <div :class="['leftBtn ',disabled ? 'normalBtn' : 'leftActiveBtn']" @click.stop="handleReset">重置</div>
        <div :class="['rightBtn ',disabled ? 'normalBtn' : 'activeBtn']" @click.stop="handleConfirm">确定</div> -->
        <div :class="['leftBtn ',disabled ? 'disableLeftBtn' : 'normalLeftBtn']" @click="handleReset">重置</div>
        <div class="rightBtn" @click="handleConfirm">确定</div>
      </div>
    </div>
  </div>
</template>
<script>
import http from "@/utils/axios";
import utils from '../../../utils/common';

export default {
  data() {
    return {
      groupId:'',
      showPopup: false,
      selectedPic: require('@/assets/image/statisticManage/selected@3x.png'),
      unSelectedPic: require('@/assets/image/statisticManage/unSelect@3x.png'),
      disabled: true,// 确定按钮是否禁用
      condition: 1,
      loading: false,
      finished: false,
      error: false,
      page: 1,
      pageSize: 10,
      filterItems: [],
      total: 0,// 预计满足条件的群的个数
      selectFilterItems: {},// 选择的筛选项的集合
      selectFilterItemIds: {},// 选择的筛选项Id的集合
      allCurrentSelecTags: []
    }
  },
  created() {
    if(!utils.isNullData(localStorage.getItem('currentGroupLabels'))){
      this.allCurrentSelecTags = JSON.parse(localStorage.getItem('currentGroupLabels'))
    }
    this.groupId = this.$route.query.groupId
    this.getGroupList()
  },
  methods: {
    handleSelectTags(){
      for(let i = 0;i < this.allCurrentSelecTags.length;i++){
        let tag = this.allCurrentSelecTags[i]
        for(let j = 0;j < this.filterItems.length;j++){
          let cObj = this.filterItems[j]
          if(tag.parentId == cObj.id){
            if(!this.selectFilterItems[cObj.id]){
              this.$set(this.selectFilterItems,cObj.id,[])
            }
            if(!this.selectFilterItemIds[cObj.id]){
              this.$set(this.selectFilterItemIds,cObj.id,[])
            }
            for(let k = 0;k < cObj.bsLabel.length;k++){
              let obj = cObj.bsLabel[k]
              if(obj.id == tag.id && this.selectFilterItemIds[cObj.id].indexOf(obj.id) < 0){
                this.selectFilterItems[cObj.id].unshift(obj)
                this.selectFilterItemIds[cObj.id].unshift(obj.id)
              }
            }
          }
        }
      }
      if (Object.keys(this.selectFilterItemIds).length > 0) {
        let list = []
        for (let key in this.selectFilterItemIds) {
          list = list.concat(this.selectFilterItemIds[key])
        }
        this.disabled = list.length == 0
      } else {
        this.disabled = true
      }
    },
    compare(property,rev){
      //第二个参数没有传递 默认升序排列
      if(rev ==  undefined){
        rev = 1;
      }else{
        rev = (rev) ? 1 : -1;
      }
      return function(a,b){
        a = a[property];
        b = b[property];
        if(a < b){
          return rev * -1;
        }
        if(a > b){
          return rev * 1;
        }
        return 0;
      }
    },
    /**
     * 获取本群未有的标签列表
     */
    getGroupList() {
      http({
        url: "order/dmp/dispatch/memberpush/BsEnterpriseWechatGroupChat/getBsLabelListForUnUser",
        method: "post",
        parmes: {
          groupId:this.groupId
        }
      }).then(rps => {
        if (rps.code == 200) {
          let data = rps.data;
          this.filterItems = data
          // this.filterItems.forEach((cItem) => {
          //   if (cItem.bsLabel && cItem.bsLabel.length > 0) {
          //     // this.$set(this.selectFilterItemIds, cItem.id, [])
          //     // this.$set(this.selectFilterItems, cItem.id, [])
          //   }
          // })
          this.handleSelectTags()
        } else {
          this.$toast('请求异常，请稍后重试')
        }
        this.$loading.hide();
      }).catch(() => {
        this.$loading.hide();
        this.$toast('请求失败，请稍后重试')
      });
    },
    /**
     * @description 选中筛选项
     * @param {*} item 筛选项所属大类
     * @param {*} fItem 筛选项
     * @param {*} index 筛选项所属大类index
     * @param {*} fIndex 筛选项index
     */
    handleSelect(item, fItem) {
      if (this.selectFilterItemIds[item.id]) {// 如果已选中的数据包含当前大类
        let filterIndex = this.selectFilterItemIds[item.id].indexOf(fItem.id)
        if (filterIndex > -1) {// 如果当前筛选项已被选中，则取消选中
          this.selectFilterItemIds[item.id].splice(filterIndex, 1)
          this.selectFilterItems[item.id].splice(filterIndex, 1)
        } else {// 选中当前筛选项
          this.selectFilterItemIds[item.id].push(fItem.id)
          fItem.title = fItem.name
          this.selectFilterItems[item.id].push(fItem)
        }
      } else {
        fItem.title = fItem.name
        this.$set(this.selectFilterItemIds, item.id, [fItem.id])
        this.$set(this.selectFilterItems, item.id, [fItem])
      }
      if (Object.keys(this.selectFilterItemIds).length > 0) {
        let list = []
        for (let key in this.selectFilterItemIds) {
          list = list.concat(this.selectFilterItemIds[key])
        }
        this.disabled = list.length == 0
      } else {
        this.disabled = true
      }
    },
    handleReset(){
      this.filterItems.forEach((cItem) => {
        if (cItem.bsLabel && cItem.bsLabel.length > 0) {
          this.$set(this.selectFilterItemIds, cItem.id, [])
          this.$set(this.selectFilterItems, cItem.id, [])
        }
      })
      this.disabled = true
    },
    // 确定
    handleConfirm() {
      if (!this.disabled) {
        // this.$emit('confirm', this.selectFilterItemIds, this.selectFilterItems)
        // this.selectFilterItemIds = {}
        // this.selectFilterItems = {}
        let selectLabels = []
        for(let key in this.selectFilterItems){
          if(this.selectFilterItems[key].length > 0){
            selectLabels = selectLabels.concat(this.selectFilterItems[key])
          }
        }
        selectLabels.forEach((item) => {
          item.labelId = item.id
          item.enterpriseWechatGroupChatId = this.groupId
          delete item.title
        })
        console.log(selectLabels)
        http({
          url: "order/dmp/dispatch/memberpush/BsEnterpriseWechatGroupChat/updateGroupLabs",
          method: "post",
          parmes: {
            groupId:this.groupId,
            bsGroupChatLabelRefs:selectLabels
          }
        }).then(rps => {
          if (rps.code == 200) {
            this.$toast('操作成功')
            setTimeout(() => {
              this.$router.go(-1)
              localStorage.setItem('refreshGroupDetail',1)
            },1000)
          } else {
            this.$toast('请求异常，请稍后重试')
          }
          this.$loading.hide();
        }).catch(() => {
          this.$loading.hide();
          this.$toast('请求失败，请稍后重试')
        });
      }
    },
  }
}
</script>
<style lang="less" scoped>
@import url("../style/index.css");

.popupView {
  position: relative;
  height: 100%;
}

.popupTopView {
  padding: 24px 24px calc(104px + constant(safe-area-inset-bottom)) 24px;
  padding: 24px 24px calc(104px + env(safe-area-inset-bottom)) 24px;
  overflow: scroll;

  .clearBtn {
    font-size: 24px;
    font-weight: 400;
    color: #E15554;
    line-height: 32px;
    margin-right: 24px;
  }

  .collapseBtn {
    font-size: 24px;
    font-weight: 400;
    color: #B4B4B4;
    line-height: 32px;
  }

  .filterView {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;

    .filterTitle {
      font-size: 28px;
      font-weight: 500;
      color: #3B3A38;
      line-height: 40px;
    }

    .filterListView {
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
      width: 100%;

      .filterItem {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 60px;
        border-radius: 30px;
        padding: 0 24px;
        font-size: 26px;
        font-weight: 400;
        line-height: 36px;
        margin: 16px 16px 0 0;
      }

      .normalItem {
        background: #F2F2F2;
        color: #62615F;
        border: 2px solid #F2F2F2;
      }

      .activeItem {
        background: rgba(68, 102, 245, 0.1);
        border: 2px solid #4466F5;
        color: #4466F5;
      }
    }
  }

  /deep/ .van-cell {
    padding: 0 0 !important;

    &::after {
      border-bottom: none !important;
    }
  }

  /deep/ .van-collapse-item__content {
    padding: 0 0 !important;
  }

  /deep/ .van-collapse-item--border {
    &::after {
      border-top: none !important;
    }
  }
}

.popupBottomView {
  position: fixed;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);

  .tipView {
    display: flex;
    flex-direction: column;
    padding: 12px 24px;
    background: #FFFAE6;

    .tipTitle {
      font-size: 24px;
      font-weight: 500;
      color: #3B3A38;
      line-height: 24px;
    }
  }

  // .actionView {
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   position: relative;
  //   padding: 10px 32px;
  //   .leftBtn{
  //     width: calc(30% - 32px);
  //     margin-right: 32px;
  //     height: 80px;
  //     display: flex;
  //     align-items: center;
  //     justify-content: center;
  //     border-radius: 40px;
  //     font-size: 28px;
  //     font-weight: 500;
  //     line-height: 40px;
  //     color: #FFFFFF;
  //   }
  //   .rightBtn {
  //     width: 70%;
  //     height: 80px;
  //     display: flex;
  //     align-items: center;
  //     justify-content: center;
  //     border-radius: 40px;
  //     font-size: 28px;
  //     font-weight: 500;
  //     line-height: 40px;
  //     color: #FFFFFF;
  //   }

  //   .normalBtn {
  //     background: #D1D1D1;
  //   }
  //   .leftActiveBtn{
  //     background: rgb(248, 213, 65);
  //   }
  //   .activeBtn {
  //     background: #4466F5;
  //   }
  // }
  .actionView {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 10px 0;
    width: 100%;

    .leftBtn {
      position: absolute;
      top: 10px;
      left: 32px;
      width: 45%;
      height: 80px;
      //background: #FFFFFF;
      border-radius: 40px 0px 40px 40px;
      //border: 2px solid #4466F5;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 28px;
      font-weight: 400;
      //color: #4466F5;
      line-height: 40px;
    }
    .normalLeftBtn{
      border: 2px solid #4466F5;
      color: #4466F5;
      background: #FFFFFF;
    }
    .disableLeftBtn{
      border: 2px solid #D1D1D1;
      color: #FFFFFF;
      background: #D1D1D1;
    }
    .rightBtn {
      width: calc(90% - 124px);
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      background: #4466F5;
      border-radius: 40px;
      padding-right: 124px;
      font-size: 28px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 40px;
      border: 2px solid #4466F5;
    }
  }
}
</style>